import { FC } from 'react';
import { SbRespContentModuleRegular_browseContentModule } from './__generated__/SbRespContentModuleRegular_browseContentModule.graphql';

import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { SbRespContentModuleBase } from './../SbRespContentModuleBase/SbRespContentModuleBase';
import { SbSharedStorefrontLink } from '../SbSharedStorefrontLink/SbSharedStorefrontLink';

type Props = {
    browseContentModule: SbRespContentModuleRegular_browseContentModule;
};

const SbRespContentModuleRegularComponent: FC<Props> = ({ browseContentModule }) => {
    const { description, title, photo } = browseContentModule;

    return (
        <SbRespContentModuleBase title={title} description={description} photo={photo}>
            <SbSharedStorefrontLink browseContentModule={browseContentModule} />
        </SbRespContentModuleBase>
    );
};

export const SbRespContentModuleRegular = createFragmentContainer(
    SbRespContentModuleRegularComponent,
    {
        browseContentModule: graphql`
            fragment SbRespContentModuleRegular_browseContentModule on ContentModuleRegular {
                ...SbSharedStorefrontLink_browseContentModule
                description
                title
                photo
            }
        `,
    }
);
